module.exports = __webpack_public_path__ + "static/media/content.5632644d.svg";